import * as React from "react";
import styled, { css } from "styled-components";

import Icon from "src/library/components/Icon/Icon";
import { Icons } from "src/library/components/Icon/types";

import { DashboardMode } from "../contexts/DashboardContext";

export interface DashboardWidgetContainerProps {
  mode: DashboardMode;
  onDelete: () => void;
  title?: string;
}

export const DashboardWidgetContainer: React.ReactFCWithChildren<DashboardWidgetContainerProps> = ({
  children, mode, title, onDelete
}) => {
  return (
    <WidgetContainerWrapper
      className="hide-scroll"
      mode={mode}
      borderAccent={!!title}
    >
      {mode === DashboardMode.Edit && (
        <div className="widget-header">
          <div className="widget-drag">
            <Icon
              icon={Icons.DRAG}
              size={20}
              $fillColor="midGrey"
            />
          </div>

          <div className="widget-delete">
            <Icon
              icon={Icons.DELETE}
              size={20}
              $fillColor="midGrey"
              onClick={onDelete}
            />
          </div>
        </div>
      )}

      {title && (
        <div className="widget-title">
          {title}
        </div>
      )}

      <div className="widget-inner">
        {children}
      </div>
    </WidgetContainerWrapper>
  );
};

const WidgetContainerWrapper = styled.div<{mode: DashboardMode; borderAccent: boolean | undefined;}>`
  ${({
    theme, mode, borderAccent = false
  }) => css`
    background: ${theme.colors.white};
    overflow: hidden;
    height: 100%;
    width: 100%;
    border: ${borderAccent ? "1px" : "2px"} solid ${theme.colors[ borderAccent ? "primaryLight" : "lightGrey" ]};
    border-radius: ${theme.borderRadius};
    position: relative;
    overflow-y: scroll;

    &.hide-scroll::-webkit-scrollbar {
      display: none;
    }
    
    &.hide-scroll {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    .widget-inner {
      padding: ${theme.spacing.padding.sm};
      /**  the -[X]px is to account for the inner header and/or the edit header */
      height: ${mode === DashboardMode.Edit ? "calc(100% - 100px)" : "calc(100% - 50px)"};
    }

    .widget-header {
      padding: ${theme.spacing.padding.sm};
      display: flex;
      width: 100%;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      background: ${theme.colors.lightestGrey};

      h2 {
        margin-bottom: 0;
      }
      
      .widget-drag {
        border-right: 1px solid ${theme.colors.midGrey};
        padding-right: ${theme.spacing.padding.sm};
        margin-right: ${theme.spacing.padding.sm};

        &:hover {
          cursor: grab;
        }
      }

      .widget-delete {
        width: 100%;
        display: flex;
        justify-content: flex-end;

        svg:hover {
          cursor: pointer;
          fill: ${theme.colors.error} !important;
        }
      }
    }

    .widget-title {
      background: ${theme.colors.primaryLight};
      color: ${theme.colors.white};
      padding: ${theme.spacing.padding.xs};
      font-size: ${theme.fonts.sizes.h5};
    }
  `}
`;